const collectionTab = document.querySelector(".collection-tab-section .collection");
const sectionIddd = collectionTab.getAttribute("data-id"); 
const cache = {};

if (collectionTab) {
  const collectionButtons = collectionTab.querySelectorAll('.collection-tab-list .button');
  const viewAllButton = collectionTab.querySelector('.collection__view-all .button');

  // 🔹 Preload sab collections page load pe
  collectionButtons.forEach((button) => {
    const handle = button.dataset.collectionHandle;
    if (handle) {
      fetch(`${handle}/?section_id=${sectionIddd}`)
        .then((response) => response.text())
        .then((html) => {
          cache[handle] = html;
        });
    }
  });

  collectionButtons.forEach((button) => {
    button.addEventListener('click', () => {
      collectionButtons.forEach((btn) => {
        btn.classList.remove('button--primary');
        btn.classList.add('button--secondary');
      });
      button.classList.add('button--primary');
      button.classList.remove('button--secondary');

      const selectedHandle = button.dataset.collectionHandle;
      if (selectedHandle && cache[selectedHandle]) {
        // Cached HTML turant inject karo
        updateCollectionHTML(cache[selectedHandle]);
      } else if (selectedHandle) {
        // Agar kisi wajah se cache nahi hua ho, fallback fetch karo
        fetch(`${selectedHandle}/?section_id=${sectionIddd}`)
          .then((response) => response.text())
          .then((html) => {
            cache[selectedHandle] = html;
            updateCollectionHTML(html);
          });
      }

      if (viewAllButton) {
        viewAllButton.setAttribute('href', selectedHandle);
      }
    });
  });
}

function updateCollectionHTML(responseText) {
  const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
  const collectionDataElement = responseHTML.querySelector(`#collection-data-${sectionIddd}`).innerHTML;
  document.getElementById('collection-data-' + sectionIddd).innerHTML = collectionDataElement;
}

